import { Injectable } from "@angular/core";
import swal from "sweetalert2";
import { AuthService } from "src/app/security/auth.service";

var interval;

@Injectable()
export class Global {

  constructor(private authService:AuthService){}

  timeLeft: number = 0; 
      
  startTimer() {
    this.timeLeft =Number.parseInt(sessionStorage.getItem('inactividad'));

    interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        
        if (this.timeLeft === Number.parseInt(sessionStorage.getItem('tiempoMensaje'))) {
          swal.fire({
            text: 'Su sesión está a punto de terminar' +
              '\n¿Desea renovarla?',
            icon: 'warning',
            showCancelButton: true,
            customClass:{
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger',
            },
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            buttonsStyling: false,
            timer:Number.parseInt(sessionStorage.getItem('tiempoMensaje'))*1000
          }).then((result) => {
            if (result.value) {
              console.log(result.value);
              
              this.authService.validateSesion().subscribe(res => {
                if (res.codigoDeRespuesta !== '00000') {
                  swal.fire({
                    icon: 'warning',
                    title: 'Su sesión ha caducado',
                    buttonsStyling: false,
                    customClass:{
                      confirmButton: 'btn btn-warning',
                      cancelButton: 'btn btn-danger',
                    },
                    confirmButtonText: 'Aceptar',
                  }).then((result) => {
                    if (result.value) {
                      //this.authService.logout();
                      this.timeLeft=0;
                    } 
                  });
                } else {
                  this.timeLeft = Number.parseInt(sessionStorage.getItem('inactividad'));
                }
              });
            } else {
              $('.cdk-overlay-container').remove();
              swal.fire({
                icon: 'warning',
                title: 'Su sesión ha caducado',
                buttonsStyling: false,
                customClass:{
                  confirmButton: 'btn btn-warning',
                  cancelButton: 'btn btn-danger',
                },
                confirmButtonText: 'Aceptar',
              }).then((result) => {
                window.location.reload();
              });
              this.authService.logout();
              this.timeLeft=0;
            }
          });
        }
      } else {
        this.pauseTimer();
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(interval);
  }
  reinciarTimer() {
    this.pauseTimer();
    this.startTimer();
  }
    
}